<template>
  <div class="col-12">
    <div class="card-booking-link">
      <div class="booking-link-data-wrap">
        <h5 class="booking-link-title">Booking link sent!</h5>
      </div>
      <div class="booking-link-data-wrap">
        <span class="booking-link-data-title">Sent Via</span>
        <span class="booking-link-data-value">{{ lead.booking_link.sent_via === 'sms' ? "SMS" : "Email" }}</span>
      </div>
      <div class="booking-link-data-wrap">
        <span class="booking-link-data-title">Sent At</span>
        <span class="booking-link-data-value">{{ lead.booking_link.sent_at }}</span>
      </div>
      <div class="booking-link-data-wrap">
        <span class="booking-link-data-title">Used At</span>
        <span class="booking-link-data-value">{{ lead.booking_link.used_at ? lead.booking_link.used_at : '/' }}</span>
      </div>
      <div class="booking-link-data-wrap">
        <span class="booking-link-data-title">Opened At</span>
        <span class="booking-link-data-value">{{ lead.booking_link.opened_at ? lead.booking_link.opened_at : '/' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingLinkSent',
  props: {
    lead: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.card-booking-link {
  background: #ffffff;
  border: 1px solid rgba(41, 98, 255, 0.6);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  margin-left: 30px;

  .booking-link-title {
    color: #000000;
    font-weight: 500;
  }

  .booking-link-data-wrap {
    width: 25%;
    display: flex;
    flex-direction: column;

    .booking-link-data-title {
      font-size: 0.7rem;
      color: #a5aeb7;
    }

    .booking-link-data-value {
      color: black;
      font-size: 0.95rem;
    }
  }
}

@media screen and (max-width: 500px) {
  .card-booking-link {
    margin: 0 10px 0 10px;
    flex-wrap: wrap;

    .booking-link-data-wrap {
      width: 50%;
      margin-bottom: 10px;

      &:first-child {
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leads/BookingLinkSent.vue